<script>
    import {createEventDispatcher} from "svelte";
    import {eventBus} from "../core/event-bus-store.js";
    const dispatch = createEventDispatcher();

    export let record;
    export let publishConfig;
    export let tenantKey;

    const addToCartHandler = (record) => {
        if (record?.prices?.length > 1 || record?.mods?.length > 0) {
            eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'addItems'}}]);
        }
        else {
            dispatch('addToCart', record);
        }
    };

    const removeFromCartHandler = (record) => {
        if (record?.prices?.length > 1 || record?.mods?.length > 0) {
            eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'removeItems'}}]);
        }
        else {
            dispatch('removeFromCart', record);
        }
    };
</script>
<style>

.record {
    width: 100%;
    /*padding-left: 1rem;*/
    /*padding-right: .5rem;*/
    gap: 2px;
}
.label {
    background: var(--accent);
    text-transform: uppercase;
    font-weight: 200;
    border-radius: 1rem;
    
    color: var(--label-text);
    line-height: 1;
    padding: 2px 8px;
    font-size: var(--fs-75);
}
.row {

}
.name {
    text-transform: uppercase;
    font-size: var(--fs-125);
    font-weight: 400;
    color: var(--primary-text);
}
hr {
    height: 1px;
    min-width: 2rem;
    border: none;
    border-bottom: 1px solid var(--semi-transpagent-red);
}
.description {
    font-weight: 200;
    padding-right: 2rem;
    white-space: pre-wrap;
    color: var(--secondary-text);
}

.weight {
    font-size: var(--fs-100);
    color: var(--light-text);
    text-transform: none;
}
.price {
    font-size: var(--fs-120);
    font-weight: 500;
}
.price--old {
    font-size: var(--fs-100);
    color: var(--light-text);
    text-decoration: line-through;
    font-weight: 200;
}
.currency {
    font-size: var(--fs-100);
    font-weight: 100;
}

</style>

{#if (!record.hidden)}

<div class="record flex-column">

    {#if (record.label)}
        <div>
            <span class="label">{ record.label }</span>
        </div>
    {/if}

    <div class="row flex ai-center gap-05">
        <div class="name wrap-anywhere">
            { record.name }

            {#if record.prices[0]?.weight}
            <span class="weight">{ record.prices[0].weight }</span>
            {/if}
        </div>

        {#if (record.prices?.length > 0 && record.prices[0]?.price !== null && record.prices[0]?.price !== undefined)}
        <hr class="flex-fill">
        <div class="price nowrap">

            {#if (record.prices[0].oldPrice !== undefined)}
                <span class="price--old">{ record.prices[0].oldPrice }</span>
            {/if}

            {#if (record._minPrice !== undefined) }
                <span>от </span>
            {/if}

            <span class="nowrap">
                <span class="price">{ record._minPrice || record.prices[0]?.price || '-' }</span>

                {#if (publishConfig?.currency)}
                    &nbsp;<span class="currency">{ publishConfig?.currency || '' }</span>
                {/if}
            </span>

        </div>

            {#if (publishConfig.disableCart !== true)}
                <div class="order-buttons" class:order-buttons--added={(record?._orderedItems || 0) > 0}>
                    {#if ( (record?._orderedItems || 0) > 0)}
                        <button class="add-button pointer" on:click|stopPropagation={removeFromCartHandler(record)}>-</button>
                        <span>{record?._orderedItems}</span>
                    {/if}
                    <button class="add-button pointer" on:click|stopPropagation={addToCartHandler(record)}>+</button>
                </div>
            {/if}

        {/if}

    </div>

    {#if (record.description)}
        <div class="description wrap-anywhere">
            { record.description }
        </div>
    {/if}

</div>

{/if}
